export default __webpack_public_path__ + "static/anna-7b3118930c589cb8c190cc4693d44d1a.png";